import NavCreators from "../../Redux/NavRedux"
import AuthCreators from "../LoginPage/reducer"
import Actions from "./reducer"

/* eslint-disable import/no-named-as-default-member */
export default {
  logout: AuthCreators.logout,
  changeTheme: NavCreators.navSetProp,
  getUserInfo: Actions.userRequest,
  setDisabledTransition: NavCreators.navSetProp
}
